import { apiClient, throwApiError } from './apiClient';

type ProgressParams = {
  geodataIds?: string[];
  simulationSetIds?: string[];
};

export async function getProgress({ geodataIds, simulationSetIds }: ProgressParams) {
  const response = await apiClient.api.progress.get({
    query: {
      geodatas_ids: geodataIds,
      'simulations-sets_ids': simulationSetIds,
    },
  });
  if (response.error) {
    throwApiError(response.error.value, response.error.status);
  }
  return response.data;
}
